import React from 'react'
import { makeStyles, Paper, Typography } from '@material-ui/core/index'

const useStyles = makeStyles({
    containerWarning: {
        marginTop: '20px',
        padding: '20px',
        backgroundColor: '#f8eac3',
        fontSize: '16px',
        lineHeight: '20px',
        display: 'flex',
        flexWrap: 'wrap'
    },
    containerSuccess: {
        marginTop: '20px',
        padding: '20px',
        backgroundColor: '#c3f8ca',
        fontSize: '16px',
        lineHeight: '20px',
        display: 'flex',
        flexWrap: 'wrap'
    },
    container: {
        marginTop: '20px',
        padding: '20px',
        backgroundColor: '#f4f3f3',
        fontSize: '16px',
        lineHeight: '20px',
        display: 'flex',
        flexWrap: 'wrap'
    },
    header: {
        width: '100%',
    },
    resultOk: {
        minWidth: 250,
        flexGrow: 1,
        padding: 8,
        backgroundColor: '#12b804',
        color: 'whitesmoke',
        borderRadius: 8,
        margin: 4,
        textAlign: 'center',
    },
    resultError: {
        minWidth: 250,
        flexGrow: 1,
        padding: 8,
        backgroundColor: '#af2022',
        color: 'whitesmoke',
        borderRadius: 8,
        margin: 4,
        textAlign: 'center',
    },
    comment: {
        width: '100%',
    }
})

export const ResumeFile = ({ total = 0, errors = 0, rowsOverflow = 0, fileError = false}) => {
    const styles = useStyles()
    
    if (fileError === true) {
        return <Paper className={styles.containerWarning}>
            <Typography variant="h5" className={styles.header}>
                El archivo que intenta subir no es válido.
            </Typography>
        </Paper>
    }
    if (rowsOverflow > 0) {
        return <Paper className={styles.containerWarning}>
            <Typography variant="h5" className={styles.header}>
                No se puede leer el archivo porque supera el máximo de {rowsOverflow} filas permitidas.
            </Typography>
        </Paper>
    }

    if (!total) {
        return <Paper className={styles.containerWarning}>
            <Typography variant="h5" className={styles.header}>
                No se encontraron registros en el archivo.
            </Typography>
        </Paper>
    }

    if (!errors) {
        return <Paper className={styles.containerSuccess}>
            <Typography variant="h5" className={styles.header}>
                Encontramos un total de {total} registros válidos en el archivo.
            </Typography>
        </Paper>
    }

    return <Paper className={styles.containerWarning}>
        <Typography variant="h5" className={styles.header}>
            Encontramos un total de {total} registros en el archivo.
        </Typography>
        <Typography className={styles.resultOk}>
            {total - errors} válidos
        </Typography>
        <Typography className={styles.resultError}>
            {errors} no válidos
        </Typography>
        <Typography variant="caption" className={styles.comment}>
            * Podés corregir los campos sobre el excel y volver a cargarlo
        </Typography>
    </Paper>
}



export const ResumeResponse = ({ total = 0, errors = 0 }) => {
    const styles = useStyles()

    if (!errors) {
        return <Paper className={styles.containerSuccess}>
            <Typography variant="h5" className={styles.header}>
                Se crearon correctamente las {total} ordenes enviadas.
            </Typography>
        </Paper>
    }

    return <Paper className={styles.containerWarning}>
        <Typography variant="h5" className={styles.header}>
            Se enviaron {total} registros para crear ordenes.
        </Typography>
        <Typography className={styles.resultOk}>
            {total - errors} creadas
        </Typography>
        <Typography className={styles.resultError}>
            {errors} no creadas
        </Typography>
        <Typography variant="caption" className={styles.comment}>
            * Las que no se crearon son listadas acá abajo. De ser necesario, podés descargarlas en excel, modificarlas y volverlas a ingresar.
        </Typography>
    </Paper>
}

